<template class="auto-container-rota">
    <div >
        <b-container fluid>
            <div v-if="trecho.length>=7" class="m-t alert alert-danger alert-no-border alert-close alert-dismissible show m-1" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
                <h1>Atenção</h1>
                <p>Você atingiu o limite de endereços, efetue o cadastro para endereços ilimitados.</p>
            </div>
            <div v-if="email_enviado" class="m-t alert alert-success alert-no-border alert-close alert-dismissible show m-1" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
                <h1>Atenção</h1>
                <p>E-mail enviado!</p>
            </div>
            <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
                <div class="match-height">
                    <div class="row" style="">
                        <div class="card col-md-7">
                            <div class="ml-0" >
                                <div class="col-md-12">
                                    <b-row class="pt-1">
                                        <b-col class="col-lg-10 pl-0">
                                            <h3 class="card-title">Rota</h3>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="col-md-12 p-0 ml-0">
                                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                              <li class="nav-item" role="presentation">
                                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Em lote <span v-b-tooltip title="Insira um endereço por linha" placement="top">[?]</span></a>
                                              </li>
                                              <li class="nav-item" role="presentation">
                                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">XML <span v-b-tooltip title="Endereço do(s) destinatário(s) será preenchido nos campos abaixo" placement="top">[?]</span></a>
                                              </li>
                                            </ul>
                                            <div class="tab-content" id="myTabContent">
                                              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                  <b-card>
                                                      <b-col md="12" sm="12" class="pt-2 p-0">
                                                        <b-form-textarea id="textarea1"
                                                                         name="obs"
                                                                         v-model.number="form.obs"
                                                                         placeholder="Endereços"
                                                                         :rows="4"
                                                                         trim
                                                                         :max-rows="7">
                                                        </b-form-textarea>
                                                        <b-btn class="mt-2" @click="populaEnderecos(form.obs)" variant="primary" :disabled="isDisabled">
                                                          Adicionar Endereços
                                                        </b-btn>
                                                      </b-col>
                                                  </b-card>
                                              </div>
                                              <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                                  <b-card>
                                                      <b-col md="12" sm="12" class="pt-2 p-0">
                                                          <b-form-group label="Large:" label-for="file-large" label-cols-sm="2" label-size="lg">
                                                              <b-form-file id="file-large" size="lg" accept=".xml" multiple v-model="files"></b-form-file>
                                                          </b-form-group>
                                                          <b-btn @click="print($event)" variant="primary" :disabled="isDisabled">
                                                            Adicionar Endereços
                                                          </b-btn>
                                                      </b-col>
                                                  </b-card>
                                              </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-row>
                                            <b-col class="col-md-10">
                                                <label>Descrição</label>
                                                <b-form-input type="text"
                                                              placeholder="Rota"
                                                              v-model="form.descr"
                                                              name="descr">
                                                </b-form-input>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                                            </b-col>
                                        </b-row>
                                        <div class="col-md-12 p-0" v-for="(row, index) in trecho">
                                            <b-row>
                                                <b-col class="col-md-10">
                                                    <label v-if="index==0">Origem</label>
                                                    <label v-if="index!=0 && index != trecho.length-1">Endereço</label>
                                                    <label v-if="index!=0 && index == trecho.length-1">Destino</label>
                                                    <b-form-input type="text"
                                                                  placeholder="Endereço"
                                                                  v-model="row.endereco"
                                                                  name="endereco">
                                                    </b-form-input>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.endereco')" v-if="form.errors.has('trecho.'+index+'.cep_origem')"></b-form-feedback>
                                                </b-col>
                                                <b-col class="col-md-2 mt-2">
                                                    <i v-if="index!==0 && index != trecho.length-1" class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover title="Remover Linha" v-on:click="removeRowTrecho(index);"></i>
                                                    <i v-if="trecho.length<7 && index==0" class="fa fa-plus" style="cursor: pointer" v-b-tooltip.hover title="Adicionar Endereço" v-on:click="addRowTrecho($event);"></i>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-7">
                                                <b-form-group label="Evitar :">
                                                  <b-form-checkbox-group id="checkbox-group-2" v-model="form.evitar" name="evitar">
                                                    <b-form-checkbox value="tolls">Pedágios</b-form-checkbox>
                                                    <b-form-checkbox value="highways">Rodovias</b-form-checkbox>
                                                    <b-form-checkbox value="ferries">Balsas</b-form-checkbox>
                                                  </b-form-checkbox-group>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-5">
                                                <b-form-group inline label="Otimizar Waypoints ? ">
                                                  <b-form-radio v-model="form.otimizar" name="some-radios" value="1">Sim</b-form-radio>
                                                  <b-form-radio v-model="form.otimizar" name="some-radios" value="2">Não</b-form-radio>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </b-row>
                                    <b-row class="mt-2">
                                        <b-btn @click="getMapa()" variant="primary" :disabled="isDisabled">
                                          Gerar mapa
                                        </b-btn>
                                    </b-row>
                                    <b-row>
                                        <div class="col-md-7">
                                            <b-collapse v-model="insereEmail" id="collapse-4">
                                                  <b-col md="12" sm="12" class="pt-2 p-0">
                                                    <label class="panel-title">Nome</label>
                                                    <b-form-input type="text"
                                                                  placeholder="Nome"
                                                                  v-model="form.nome"
                                                                  name="nome">
                                                    </b-form-input>
                                                  </b-col>
                                                  <b-col md="12" sm="12" class="pt-2 p-0">
                                                    <label class="panel-title">E-mail</label>
                                                    <b-form-input type="text"
                                                                  placeholder="E-mail"
                                                                  v-model="form.email"
                                                                  name="email">
                                                    </b-form-input>
                                                  </b-col>
                                                  <b-col class="pt-2 p-0">
                                                      <b-btn @click="enviaEmail()" variant="primary" :disabled="isDisabled">
                                                        Enviar rota por e-mail
                                                      </b-btn>
                                                  </b-col>
                                            </b-collapse>
                                        </div>
                                    </b-row>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-5">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="isLoadingMapa"><div class="loadingDataSpinner"><spinner v-if="isLoadingMapa" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                     <b-embed
                                      type="iframe"
                                      aspect="16by9"
                                      v-bind:src="dados_mapa"
                                      allowfullscreen
                                    ></b-embed>
                                    <i v-if="v2_instrucoes_mapa.length>0" class="fa fa-bars" style="cursor: pointer" v-b-toggle.collapse-1 v-b-tooltip.hover title="'Ver outras instruções'"></i>
                            </div>
                            <div class="pt-1" v-if="instrucoes_mapa" v-for="item in v1_instrucoes_mapa">
                                <b-col>
                                        <b-list-group >
                                          <b-list-group-item style="font-size: 16px; padding:8px; margin-bottom: 10px;" v-html="item.instrucoes"></b-list-group-item>
                                        </b-list-group>
                                </b-col>
                            </div>
                            <div v-if="instrucoes_mapa" v-for="item2 in v2_instrucoes_mapa">
                                <b-col>
                                    <b-collapse id="collapse-1">
                                        <b-card>
                                            <b-list-group >
                                              <b-list-group-item style="font-size: 16px; padding:8px; margin-bottom: 10px;" v-html="item2.instrucoes"></b-list-group-item>
                                            </b-list-group>
                                        </b-card>
                                    </b-collapse>
                                </b-col>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>


export default {
    data () {
       return {
          showModal: false,
          isDisabled: false,
          loading: false,
          isLoadingMapa: false,
          isFullscreen: false,
          insereEmail: false,
          instrucoes_mapa: [],
          v1_instrucoes_mapa: [],
          v2_instrucoes_mapa: [],
          trecho2 : [],
          email_enviado: false,
          files: [],
          dados_mapa: 'https://www.google.com/maps/embed/v1/view?key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90&center=-16.840434,-57.471702&zoom=3',
          trecho: [{
                endereco: '',
                tp_trecho: 1,
                index: 0,
              },
              {
                    endereco: '',
                    tp_trecho: 3,
                    index: 1,
                }],
          form: new Form({distancia_mapa: '',
                          trecho: [],
                          email: '',
                          nome: '',
                          descr: '',
                          texto: '',
                          rota: '',
                          obs: '',
                          nome: '',
                          email: '',
                          evitar: [],
                          otimizar: 2
                      }),
        }
    },
    mounted() {

      },
    methods: {
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        getMapa() {
        this.isLoadingMapa = true;
        this.vt_waypoint = null;
        this.waypoint = '';
        this.evitar = '';
        this.v1_waypoint = '';
        this.v2_waypoint = '';
        this.trecho.forEach((obj, index) => {
            if(index == 0)
            {
                this.origem = obj.endereco.replace(/,/g," ");
                this.origem = this.origem.replace(/ /g,"+");
            }
            else if(index == this.trecho.length-1)
            {
                this.destino = obj.endereco.replace(/,/g," ");
                this.destino = this.destino.replace(/ /g,"+");
            }
            else
            {
                this.meio = obj.endereco.replace(/,/g," ");
                this.waypoint = this.meio.replace(/ /g,"+");
                if(this.v2_waypoint=='')
                {
                    this.v2_waypoint = this.waypoint;
                }
                else if(this.v2_waypoint!=='' && this.waypoint!=='')
                {
                    this.v2_waypoint = this.v2_waypoint+"|"+this.waypoint;
                }
            }
            if(this.v2_waypoint!=='' && this.v1_waypoint!=='')
            {
                this.vt_waypoint = this.v2_waypoint+"|"+this.v1_waypoint;
            }
            else if(this.v2_waypoint=='' && this.v1_waypoint!=='')
            {
                this.vt_waypoint = this.v1_waypoint;
            }
            else if(this.v2_waypoint!=='' && this.v1_waypoint=='')
            {
                this.vt_waypoint = this.v2_waypoint;
            }
        })
        this.dados_mapa = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90&origin='+this.origem+'&destination='+this.destino+'&language=pt-BR';
        this.distancia_mapa = 'https://maps.googleapis.com/maps/api/directions/json?origin='+this.origem+'&destination='+this.destino+'&language=pt-BR&key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90';
        //Opçoes para evitar, balsas, pedagios
        if(this.form.evitar.length>0)
        {
            this.form.evitar.forEach((item, index) => {
                if(this.evitar== '')
                {
                    this.evitar = item;
                }
                else
                {
                    this.evitar = this.evitar+"|"+item;
                }
            });
            this.dados_mapa = this.dados_mapa+'&avoid='+this.evitar;
            this.distancia_mapa = this.distancia_mapa+'&avoid='+this.evitar;
        }
        if(this.form.otimizar==1)
        {
            this.distancia_mapa = this.distancia_mapa+'&waypoints=optimize:true|'+this.vt_waypoint;
        }
        console.log(this.dados_mapa);
        this.form.distancia_mapa = this.distancia_mapa;
        this.form.trecho = this.trecho;
        this.trecho2 = [];
        this.trecho.forEach((item, i) => {
            if(i==0)
            {
                this.trecho2.push({
                    endereco: item,
                    tp_trecho: 1,
                    index: i
                })
            }
        });

        this.form.post('/api/rota/store/gerarota').then(response => {
            new ReturnApi(response, this);
                this.form.texto = response.va_texto;
                this.form.rota = response.rota;
                this.v1_instrucoes_mapa = [];
                this.v2_instrucoes_mapa = [];
                if(this.form.otimizar == 1)
                {
                    this.vt_waypoint = null;
                    this.waypoint = '';
                    this.evitar = '';
                    this.v1_waypoint = '';
                    this.v2_waypoint = '';
                    console.log(response);
                    response.ordem_waypoints.forEach((item, i) => {
                        this.trecho.forEach((item2, i2) => {
                            //0+1 == 0
                            //0+1 == 1
                            if(i2 == 0)
                            {
                                this.trecho2[i2] = {
                                    endereco: item2.endereco,
                                    tp_trecho: 1,
                                    index: i2
                                }
                            }
                            if(i+1 == i2)
                            {
                                this.trecho2[item+1] = {
                                    endereco: item2.endereco,
                                    tp_trecho: 2,
                                    index: (item+1)
                                }
                            }
                            if(i2 == this.trecho.length-1)
                            {
                                this.trecho2[i2] = {
                                    endereco: item2.endereco,
                                    tp_trecho: 3,
                                    index: i2
                                }
                            }
                        });
                    });
                    this.trecho = this.trecho2;
                    this.trecho.forEach((obj, index) => {
                        if(index == 0)
                        {
                            this.origem = obj.endereco.replace(/,/g," ");
                            this.origem = this.origem.replace(/ /g,"+");
                        }
                        else if(index == this.trecho.length-1)
                        {
                            this.destino = obj.endereco.replace(/,/g," ");
                            this.destino = this.destino.replace(/ /g,"+");
                        }
                        else
                        {
                            this.meio = obj.endereco.replace(/,/g," ");
                            this.waypoint = this.meio.replace(/ /g,"+");
                            if(this.v2_waypoint=='')
                            {
                                this.v2_waypoint = this.waypoint;
                            }
                            else if(this.v2_waypoint!=='' && this.waypoint!=='')
                            {
                                this.v2_waypoint = this.v2_waypoint+"|"+this.waypoint;
                            }
                        }
                        if(this.v2_waypoint!=='' && this.v1_waypoint!=='')
                        {
                            this.vt_waypoint = this.v2_waypoint+"|"+this.v1_waypoint;
                        }
                        else if(this.v2_waypoint=='' && this.v1_waypoint!=='')
                        {
                            this.vt_waypoint = this.v1_waypoint;
                        }
                        else if(this.v2_waypoint!=='' && this.v1_waypoint=='')
                        {
                            this.vt_waypoint = this.v2_waypoint;
                        }
                    })
                }
                console.log(this.trecho);
                //Adiciona os waypoints
                if(this.vt_waypoint!==null)
                {
                    this.dados_mapa = this.dados_mapa+'&waypoints='+this.vt_waypoint;
                }
                response.va_texto.forEach((obj, index) => {
                    if(index<10)
                    {
                        this.v1_instrucoes_mapa.push({
                            instrucoes: "Em "+obj.distancia+" "+obj.instrucoes,
                        })
                    }
                    else if(index>=10)
                    {
                        this.v2_instrucoes_mapa.push({
                            instrucoes: obj.distancia+" "+obj.instrucoes,
                        })
                    }
                });
        this.instrucoes_mapa = response.va_texto;
        this.insereEmail = true;
            //this.trecho.forEach((obj, index) => {
            //    obj.distancia = response.va_distancias[index].distancia;
            //})
        })
        .catch(errors => {
            new ReturnApi(errors, this)
        });
        this.isLoadingMapa = false;
    },
    populaEnderecos(data) {
        this.va_linhas = data.split("\n");
        if(this.va_linhas.length<=7)
        {
            this.trecho = [];
                this.va_linhas.forEach((obj, index) => {
                    if(obj!=='')
                    {
                        if(index==0)
                        {
                            this.trecho.push({
                                endereco: obj,
                                tp_trecho: 1,
                                index: index
                            })
                        }
                        else if(index == 1)
                        {
                            this.trecho.push({
                                endereco: obj,
                                tp_trecho: 3,
                                index: index
                            })
                        }
                        else
                        {
                            this.trecho.push({
                                endereco: obj,
                                tp_trecho: 2,
                                index: index
                            })
                        }
                    }
            });
        }
    },
    print(e)
    {
        this.loading = true;
        this.isDisabled = true;
        e.preventDefault();
        /*
          Initialize the form data
        */
        let formData = new FormData();
        /*
          Iteate over any file sent over appending the files
          to the form data.
        */
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];
          formData.append('files[' + i + ']', file);
        }
        /*
          Make the request to the POST /select-files URL
        */
        axios.post( 'api/rota/xml',
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
      ).then(response => {
            this.trecho = [];
            response.data.va_enderecos.forEach((obj, index) => {
                if(obj!=='')
                {
                    if(index==0)
                    {
                        this.trecho.push({
                            endereco: obj.endereco,
                            tp_trecho: 1,
                            index: index
                        })
                    }
                    else if(index == 1)
                    {
                        this.trecho.push({
                            endereco: obj.endereco,
                            tp_trecho: 3,
                            index: index
                        })
                    }
                    else
                    {
                        this.trecho.push({
                            endereco: obj.endereco,
                            tp_trecho: 2,
                            index: index
                        })
                    }
                }

            });
            this.loading = false;
            this.isDisabled = false;
        });
    },
    enviaEmail() {
        this.form.post('/api/rota/store').then(response => {
            new ReturnApi(response, this)
            this.email_enviado = true;
        })
        .catch(errors => {
            new ReturnApi(errors, this)
        });
    },
    addRowTrecho: function(e) {
        e.preventDefault();
        this.index = this.trecho.length;
        this.trecho.push({
            endereco: '',
            tp_trecho: 2,
            index: this.index,
        });
    },
    removeRowTrecho: function(index) {
        this.trecho.splice(index, 1);
    },
    },
 }
 </script>
